import actionTypes from '../constants/action-types';
import operations from '../operations';

const errorHandler = () => (next) => (action) => {
  switch (action.type) {
    case actionTypes.SET_CRITICAL_ERROR: {
      const { error, errorInfo, logSentry } = action.payload;

      if (logSentry) {
        operations.catchError(error, errorInfo);
      }

      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default errorHandler;
